export function getErrorConfig(code, t) {
  switch (code) {
  //Acc not found
  case 20001:
    return {
      code: 20001,
      title: t("error.20001.title"),
      description: t("error.20001.description"),
      content: t("error.20001.content"),
      content1: t("error.20001.content1"),
      image: "/image/no_accounts.svg",
      actionLabel: t("error.20001.actionLabel"),
      phoneNubmer: t("error.20001.actionType.phone.value"),
      mailId: t("error.20001.actionType.mail.value"),
    };
    //system error
  case 40001:
    return {
      code: 40001,
      title: t("error.40001.title"),
      description: t("error.40001.description"),
      content: t("error.40001.content"),
      image: "/image/computer_cancel.svg",
      actionLabel: t("error.40001.actionLabel"),
    };
    //data loading error
  case 30001:
    return {
      code: 30001,
      title: t("error.30001.title"),
      description: t("error.30001.description"),
      content: t("error.30001.content"),
      image: "/image/data_loading.svg",
      actionLabel: t("error.30001.actionLabel"),
      phoneNubmer: t("error.30001.actionType.phone.value"),
      mailId: t("error.30001.actionType.mail.value"),
    };

  default:
    return {
      title: t("error.40001.title"),
      description: t("error.40001.description"),
      content: t("error.40001.content"),
      image: "/image/computer_cancel.svg",
      actionLabel: t("error.40001.actionLabel"),
    };
  }
}
